// extracted by mini-css-extract-plugin
export default {"Container":"AdminPage_Container__XO4qj","Header":"AdminPage_Header__Fos6b","Line":"AdminPage_Line__8X9wm"};